import React, { FC } from 'react';
import Form from 'components/Form';

import { JontexPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Jontex: FC<JontexPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Jontex;
